import React, { FC } from "react";
import type { CentralBanksHeroProps } from "@/types";
import { SwiperCoverflow } from "../swiper";
import { TextCols } from "../text-cols";

export const CentralBanksHero: FC<CentralBanksHeroProps> = ({
  label,
  title,
  description,
  gallery,
}) => {
  return (
    <section className="centralBanksHero">
      <div className="wrapper">
        <TextCols
          headingLevel="h1"
          size="lg"
          label={label}
          content={{
            title,
            textCol1: description.textCol1,
            textCol2: description.textCol2,
          }}
          maxTitleWidth={937}
        />
      </div>
      <SwiperCoverflow slides={gallery} className="centralBanksHero--swiper" />
    </section>
  );
};
